import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { FileBox, LogOut, Shield, Activity } from 'lucide-react';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [healthStatus, setHealthStatus] = useState('online');

  useEffect(() => {
    // Mock health check
    const interval = setInterval(() => {
      setHealthStatus('online');
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  const isAdminPage = location.pathname === '/admin';

  return (
    <nav className="bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <div className="flex-shrink-0 flex items-center cursor-pointer" onClick={() => navigate('/dashboard')}>
              <div className="inline-flex items-center justify-center w-10 h-10 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-lg">
                <FileBox className="h-6 w-6 text-white" />
              </div>
              <span className="ml-3 text-xl font-bold text-gray-900">Files Hub</span>
            </div>

            <div className="ml-8 flex items-center space-x-2">
              <Activity className={`h-4 w-4 ${healthStatus === 'online' ? 'text-green-500' : 'text-red-500'}`} />
              <span className="text-sm text-gray-600">
                Backend: <span className={healthStatus === 'online' ? 'text-green-600 font-medium' : 'text-red-600 font-medium'}>{healthStatus}</span>
              </span>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            {user?.is_admin && (
              <Button
                onClick={() => navigate(isAdminPage ? '/dashboard' : '/admin')}
                variant="outline"
                size="sm"
                className="border-teal-200 text-teal-700 hover:bg-teal-50"
              >
                <Shield className="h-4 w-4 mr-2" />
                {isAdminPage ? 'Dashboard' : 'Admin Panel'}
              </Button>
            )}

            <div className="flex items-center space-x-3">
              <img
                src={user?.avatar_url}
                alt={user?.name}
                className="w-8 h-8 rounded-full ring-2 ring-teal-100"
              />
              <span className="text-sm font-medium text-gray-700 hidden sm:block">{user?.name || user?.username}</span>
            </div>

            <Button
              onClick={logout}
              variant="ghost"
              size="sm"
              className="text-gray-600 hover:text-gray-900"
            >
              <LogOut className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
